import React, { useEffect, useState } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Accordion from '@material-ui/core/Accordion'
import Typography from '@material-ui/core/Typography'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import { useFormikContext } from 'formik'

import { useProjectFormStyles } from '../project-form.styles'
import { FormValuesProjectRequest } from '../../projects.types'
import { Editor } from '../Editor'
import styles from './project-form-others.module.scss'
import { TranslationDictionary } from '@plandi/common'

type Props = {
  translate?: TranslationDictionary['data']
}

export const ProjectFormOthers: React.FC<Props> = ({ translate }) => {
  const classes = useProjectFormStyles()
  const [editorLoaded, setEditorLoaded] = useState(false)
  const formik = useFormikContext<FormValuesProjectRequest>()

  useEffect(() => {
    setEditorLoaded(true)
  }, [])

  return (
    <Accordion className={classes.accordion} elevation={2} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">
          {translate?.['office-site']['settings-page']['other']}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <div className={styles.editorWrapper} style={{ marginTop: 10 }}>
          <Typography
            className={classes.editorTitle}
            variant="body2"
            color="primary"
            gutterBottom
          >
            {translate?.shop['project-page']['appointment']}
          </Typography>
          <Editor
            onChange={(event: Event) =>
              formik.setFieldValue('appointment', event)
            }
            editorLoaded={editorLoaded}
            disabled={formik.isSubmitting}
            name="appointment"
            value={formik.values.appointment}
            error={Boolean(formik.errors.appointment)}
          />
        </div>

        <div className={styles.editorWrapper} style={{ marginTop: 17 }}>
          <Typography
            className={classes.editorTitle}
            variant="body2"
            color="primary"
            gutterBottom
          >
            {translate?.shop['project-page']['composition-project']}
          </Typography>
          <Editor
            onChange={(event: Event) =>
              formik.setFieldValue('projectComposition', event)
            }
            editorLoaded={editorLoaded}
            disabled={formik.isSubmitting}
            name="projectComposition"
            value={formik.values.projectComposition}
            error={Boolean(formik.errors.projectComposition)}
          />
        </div>

        <div className={styles.editorWrapper} style={{ marginTop: 17 }}>
          <Typography
            className={classes.editorTitle}
            variant="body2"
            color="primary"
            gutterBottom
          >
            {translate?.shop['project-page']['notes']}
          </Typography>
          <Editor
            onChange={(event: Event) => formik.setFieldValue('notes', event)}
            disabled={formik.isSubmitting}
            editorLoaded={editorLoaded}
            name="notes"
            value={formik.values.notes}
            error={Boolean(formik.errors.notes)}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}
